if (!customElements.get('shop-the-look')) {
  customElements.define(
    'shop-the-look',

    class ShopTheLook extends HTMLElement {
      constructor() {
        super();
        this.containerID = this.getAttribute('data-id');
        this.container = document.getElementById(this.containerID);
        this.stl_items = this.container.querySelectorAll('.collection-itemlink');
        this.stlcloseO = this.container.querySelectorAll('.cc__stloverlay, .cc__stlclose');
      }

      connectedCallback() {
        this.stl_items.forEach(item => {
          item.addEventListener('click', this.openItem.bind(this));
        });

        this.stlcloseO.forEach(item => {
          item.addEventListener('click', this.closeItem.bind(this));
        });
      }

      openItem(e) {
        const targetUrl = e.currentTarget.getAttribute('data-target');
        document.getElementById(targetUrl)?.classList.add('stlopen');

        document.dispatchEvent(
          new CustomEvent('theme:resize:width', {
            bubbles: true,
          })
        );
      }

      closeItem(e) {
        const btn = e.currentTarget.closest('button');
        const targetClose = btn ? btn.dataset.close : null;

        if (targetClose) {
          document.getElementById(targetClose)?.classList.remove('stlopen');
          return;
        }

        e.currentTarget.closest('.stlopen')?.classList.remove('stlopen');
      }
    }
  );
}

if (!customElements.get('cc-quick-add')) {
  customElements.define(
    'cc-quick-add',

    class CCQuickAdd extends HTMLElement {
      constructor() {
        super();

        this.form             = this.querySelector('form');
        this.sectionID        = this.form.dataset.blockid;
        this.inputId          = this.form.querySelector('.qa-variant-id');
        
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        this.submitButton     = this.form.querySelector('.cc_qa');
        this.selector         = this.querySelector('.cc_qa-selector');
        if( this.selector ){
          this.currentSel       = this.selector.querySelector('.cc_qa-current');
          this.options          = this.selector.querySelectorAll('.cc_qa-varitem');
        }
        this.productPrice     = document.querySelector(`#stl-${this.sectionID} .cc__stlprice`);

        this.productJSON      = this.querySelector('[data-productJSON]');
      }

      connectedCallback() {
        if( !this.selector ) return;
        this.options.forEach(item => {
          item.addEventListener('click', this.setCurrentVariant.bind(this));
        });

        this.selector.addEventListener('click', this.openOptions.bind(this));
      }

      setCurrentVariant(e) {
        // Prevent parent .cc_qa-selector click event from toggling again
        e.stopPropagation();

        const productId = e.currentTarget.getAttribute('data-id');
        this.inputId.value = productId;
        this.currentSel.textContent = e.currentTarget.innerText;

        // Close the dropdown
        this.selector.classList.remove('cc_qa-open');

        let currentJSON           = JSON.parse(this.productJSON.textContent);
        let currentData           = currentJSON.variants.find((item) => item.id == productId );
        let currentPrice          = currentData.price ? window.theme.formatMoney(currentData.price, theme.moneyFormat) : '';
        let currentPriceCompare   = currentData.compare_at_price ? window.theme.formatMoney(currentData.compare_at_price, theme.moneyFormat) : '';

        if( !currentPriceCompare ){
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
        } else {
          this.productPrice.querySelector('.new-price').textContent = currentPrice;
          this.productPrice.querySelector('.old-price').textContent = currentPriceCompare;
        }
      }

      openOptions(e) {
        this.selector.classList.toggle('cc_qa-open');
      }

      onSubmit(e){
        e.preventDefault();

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: {
              button: this.submitButton,
            },
            bubbles: false,
          })
        );

      }

      toggleSubmitButton(disable = true, text = window.theme.strings.addToCart) {
        this.submitButton.toggleAttribute('disabled', disable);
        this.submitButtonText.textContent = text;
      }
    }
  );
}

// CUSTOM TAB COLLECTIONS
document.querySelectorAll('.tab-link').forEach((item)=>{
  item.addEventListener('click', et=>{
      let sectionidd = et.currentTarget.dataset.section;
      let dataurl = et.currentTarget.dataset.url;

      if( sectionidd && dataurl ){
          document.getElementById(sectionidd).querySelector('.btnholder a').href = dataurl;
      }
  })
});
// END CUSTOM TAB COLLECTIONS

const btn = document.querySelector('button[data-add-to-cart]');
const formWrapper = document.querySelector('.form__wrapper[data-form-wrapper]');

if (btn && formWrapper) {
  // Set the correct class based on initial state BEFORE observing
  formWrapper.classList.toggle('variant--soldout', btn.hasAttribute('disabled'));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        const isDisabled = btn.hasAttribute('disabled');

        // Only act if the state actually changed
        if (mutation.oldValue === null && !isDisabled) continue;
        if (mutation.oldValue !== null && isDisabled) continue;

        formWrapper.classList.toggle('variant--soldout', isDisabled);
      }
    }
  });

  observer.observe(btn, {
    attributes: true,
    attributeFilter: ['disabled'],
    attributeOldValue: true  // Needed to access mutation.oldValue
  });
} else {
  console.warn('Button or form wrapper not found.');
}

/* ============================================================
   Product Fit — Tooltip (mouse + touch)
   ============================================================ */

(function () {
  const tooltip    = document.getElementById('fit-tooltip');
  const items      = document.querySelectorAll('.product-fit__item');
  const OFFSET_Y   = 10;
  let   activeItem = null;

  /* ---- Positioning ---- */
  function positionTooltip(item) {
    const rect     = item.getBoundingClientRect();
    const tipW     = tooltip.offsetWidth;
    const tipH     = tooltip.offsetHeight;
    const vw       = window.innerWidth;
    const vh       = window.innerHeight;

    // Default: tooltip below the item
    let top     = rect.bottom + OFFSET_Y;
    let flipped = false;

    // Flip above if tooltip would go off the bottom of the screen
    if (top + tipH > vh - 8) {
      top     = rect.top - tipH - OFFSET_Y;
      flipped = true;
    }

    // Centre horizontally over item, clamped within viewport
    let left = rect.left + rect.width / 2 - tipW / 2;
    left = Math.max(8, Math.min(left, vw - tipW - 8));

    tooltip.style.left = left + 'px';
    tooltip.style.top  = top  + 'px';
    tooltip.classList.toggle('is-flipped', flipped);
  }

  function showTooltip(item) {
    const text = item.dataset.tooltip;
    if (!text) return;
    activeItem = item;
    tooltip.textContent = text;
    tooltip.setAttribute('aria-hidden', 'false');
    tooltip.classList.add('is-visible');
    positionTooltip(item);
  }

  function hideTooltip() {
    activeItem = null;
    tooltip.classList.remove('is-visible', 'is-flipped');
    tooltip.setAttribute('aria-hidden', 'true');
  }

  /* ---- Mouse events (desktop) ---- */
  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () { showTooltip(item); });
    item.addEventListener('mouseleave', hideTooltip);
    item.addEventListener('focusin',    function () { showTooltip(item); });
    item.addEventListener('focusout',   hideTooltip);

    if (!item.hasAttribute('tabindex')) {
      item.setAttribute('tabindex', '0');
    }
  });

  /* ---- Touch events (mobile) ---- */
  // On touch devices hover doesn't fire, so tap toggles the tooltip.
  items.forEach(function (item) {
    item.addEventListener('touchend', function (e) {
      e.preventDefault(); // stop the synthetic mouse events that follow

      if (activeItem === item) {
        // Second tap on same item → hide
        hideTooltip();
      } else {
        showTooltip(item);
      }
    }, { passive: false });
  });

  // Tap anywhere outside the items → hide
  document.addEventListener('touchend', function (e) {
    if (!e.target.closest('.product-fit__item')) {
      hideTooltip();
    }
  }, { passive: true });

  // Hide on scroll (position would be stale)
  window.addEventListener('scroll', hideTooltip, { passive: true });
  window.addEventListener('resize', function () {
    if (activeItem) positionTooltip(activeItem);
  }, { passive: true });

})();